import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-expansion-panel',
  templateUrl: './expansion-panel.component.html',
  styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelComponent implements OnInit {
  @Input() documentList: any[] = [];
  @Output() add = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  constructor(private snackBar: MatSnackBar) { }

  ngOnInit(): void {
  }

  addDocument(eventFile: any, type: string, indexType: number) {
    const selectedFiles = eventFile?.target?.files as FileList;

    if (!selectedFiles?.length) {
      return;
    }

    const currentFiles = this.documentList[indexType]?.files ?? [];
    const normalizedCurrentNames = currentFiles
      .map((file: any) => this.normalizeFileName(file?.name))
      .filter(Boolean);

    const hasDuplicate = Array.from(selectedFiles).some((file: File) =>
      normalizedCurrentNames.includes(this.normalizeFileName(file.name))
    );

    if (hasDuplicate) {
      this.snackBar.open('Um ou mais documentos duplicados. Esses arquivos já foram importados.', 'OK', {
        duration: 3500
      });
      return;
    }

    this.add.emit({ eventFile, type, indexType });
  }

  normalizeFileName(fileName: string): string {
    return fileName?.toLowerCase() ?? '';
  }

  deleteDocument(id: string, typeIndex: number, fileIndex: number) {
    this.delete.emit({ id, typeIndex, fileIndex });
  }


  isDocumentComplete(doc: any): boolean {
    if (doc.type === 'PENULTIMO_BALANCO') {
      return doc.files.length >= 2 && doc.files.every((f: any) => f.name);
    }

    return !!doc.files.length && !!doc.files[0]?.name;
  }
}
